export const TICKET_NAME_MAX_LENGTH = 1024;
